import { sendAmplitudeEvent } from '@html/_common/utils';

const SELECTOR_DAY_IMAGES = '.js-ao-tour-structured-itinerary__day-images';
const SELECTOR_DAY_IMAGES_ARROW_LEFT = '.js-ao-tour-structured-itinerary__day-images-arrow-left';
const SELECTOR_DAY_IMAGES_ARROW_RIGHT = '.js-ao-tour-structured-itinerary__day-images-arrow-right';
const SELECTOR_DAY_IMAGES_PIC = '.js-ao-tour-structured-itinerary__day-images-pic';
const DAY_IMAGES_PIC_VISIBLE_CLASS = 'ao-tour-structured-itinerary__day-images-pic--visible';
const HID_CLASS = 'hid';

export default function AOStructuredItinerary() {
  const addImageArrayHandler = () => {
    // Handle left arrow click
    $(document).on('click', SELECTOR_DAY_IMAGES_ARROW_LEFT, (event) => {
      const $arrow = $(event.currentTarget);
      const $dayImagesContainer = $arrow.closest(SELECTOR_DAY_IMAGES);
      const $visibleImage = $dayImagesContainer.find(`.${DAY_IMAGES_PIC_VISIBLE_CLASS}`);
      const $allImages = $dayImagesContainer.find(SELECTOR_DAY_IMAGES_PIC);
      const $leftArrow = $dayImagesContainer.find(SELECTOR_DAY_IMAGES_ARROW_LEFT);
      const $rightArrow = $dayImagesContainer.find(SELECTOR_DAY_IMAGES_ARROW_RIGHT);

      if ($allImages.length <= 1) return; // No need to rotate if only one image

      // Remove visible class from current image
      $visibleImage.removeClass(DAY_IMAGES_PIC_VISIBLE_CLASS);

      // Get current index
      const currentIndex = $allImages.index($visibleImage);

      // Calculate previous index (no wrap-around)
      const previousIndex = currentIndex - 1;

      // Add visible class to previous image
      $allImages.eq(previousIndex).addClass(DAY_IMAGES_PIC_VISIBLE_CLASS);

      // Update arrow visibility
      if (previousIndex === 0) {
        $leftArrow.addClass(HID_CLASS);
      }
      $rightArrow.removeClass(HID_CLASS);

      sendAmplitudeEvent({
        ampEventName: 'tdp_itinerary_image_clicked',
        tdp_itinerary_image_clicked_direction: 'Previous',
      });
    });

    // Handle right arrow click
    $(document).on('click', SELECTOR_DAY_IMAGES_ARROW_RIGHT, (event) => {
      const $arrow = $(event.currentTarget);
      const $dayImagesContainer = $arrow.closest(SELECTOR_DAY_IMAGES);
      const $visibleImage = $dayImagesContainer.find(`.${DAY_IMAGES_PIC_VISIBLE_CLASS}`);
      const $allImages = $dayImagesContainer.find(SELECTOR_DAY_IMAGES_PIC);
      const $leftArrow = $dayImagesContainer.find(SELECTOR_DAY_IMAGES_ARROW_LEFT);
      const $rightArrow = $dayImagesContainer.find(SELECTOR_DAY_IMAGES_ARROW_RIGHT);

      if ($allImages.length <= 1) return; // No need to rotate if only one image

      // Remove visible class from current image
      $visibleImage.removeClass(DAY_IMAGES_PIC_VISIBLE_CLASS);

      // Get current index
      const currentIndex = $allImages.index($visibleImage);

      // Calculate next index (no wrap-around)
      const nextIndex = currentIndex + 1;

      // Add visible class to next image
      $allImages.eq(nextIndex).addClass(DAY_IMAGES_PIC_VISIBLE_CLASS);

      // Update arrow visibility
      if (nextIndex === $allImages.length - 1) {
        $rightArrow.addClass(HID_CLASS);
      }
      $leftArrow.removeClass(HID_CLASS);

      sendAmplitudeEvent({
        ampEventName: 'tdp_itinerary_image_clicked',
        tdp_itinerary_image_clicked_direction: 'Next',
      });
    });
  };

  const initiate = () => {
    addImageArrayHandler();
  };

  return {
    initiate,
  };
}
